// 图书检索
export const BOOK_SEARCH = 'BOOK_SEARCH';

// 高级检索
export const ADVANCED_SEARCH = 'ADVANCED_SEARCH';

// 上一页
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE';

// 下一页
export const NEXT_PAGE = 'NEXT_PAGE';

// 图书地址
export const BOOK_ADDRESS = 'BOOK_ADDRESS';

export const UNDO_BG = 'UNDO_BG';

export const SEARCH_CONDITION = 'SEARCH_CONDITION';


// WEBPACK FOOTER //
// ./src/constants/searchInfoConstants.js